"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IndeterminateCheckboxGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Checkbox = _interopRequireWildcard(require("./Checkbox.js"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const states = {
  UNCHECKED: 'UNCHECKED',
  INDETERMINATE: 'INDETERMINATE',
  CHECKED: 'CHECKED'
};
function valueFromEvent(event) {
  if ('persist' in event) event.persist();
  if (!event.target) return states.UNCHECKED;
  const t = event.nativeEvent.target;
  return getCheckboxState(t);
}
function getCheckboxState(checkbox, checked, checkedChildPropType) {
  if (checkbox.checked || checked || checkedChildPropType) return states.CHECKED;else if (checkbox.indeterminate) return states.INDETERMINATE;
  return states.UNCHECKED;
}
function evaluateGroupState(stateArray) {
  if (stateArray.includes(states.INDETERMINATE)) return states.INDETERMINATE;
  if (stateArray.includes(states.CHECKED)) {
    if (stateArray.includes(states.UNCHECKED)) return states.INDETERMINATE;
    return states.CHECKED;
  }
  return states.UNCHECKED;
}
const IndeterminateCheckboxGroup = (0, _react.forwardRef)((props, ref) => {
  const {
    children,
    checked,
    indeterminate,
    onChange,
    onStateChange,
    ...rest
  } = props;
  const [groupState, setGroupState] = _react.default.useState(_react.default.Children.toArray(children).map(child => getCheckboxState(child, checked, child.props.checked)));
  const onChangeRef = _react.default.useRef(onChange);
  const containerRef = _react.default.useRef(null);
  const currentState = evaluateGroupState(groupState);
  const _ref = ref || _react.default.useRef(null);
  const baseClass = `${rest.className || ''} ${rest.prefix || ''}checkbox-group-control`.trim();
  _react.default.useEffect(() => {
    if (typeof checked !== 'undefined' && !indeterminate) {
      const newState = checked ? states.CHECKED : states.UNCHECKED;
      setGroupState(s => {
        if (evaluateGroupState(s) === newState) return s;
        return [...s.fill(newState)];
      });
    }
  }, [checked, indeterminate]);
  _react.default.useEffect(() => {
    if (onChangeRef.current) onChangeRef.current({
      type: 'change',
      target: _ref.current,
      nativeEvent: {
        target: _ref.current
      }
    });
    if (onStateChange) {
      onStateChange(groupState);
    }
  }, [groupState]);
  _react.default.useEffect(() => {
    setGroupState(_react.default.Children.toArray(children).map(child => getCheckboxState(child, checked, child.props.checked)));
  }, [_react.default.Children.toArray(children).length]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Checkbox.default, _extends({}, rest, {
    ref: _ref,
    onChange: event => {
      const value = valueFromEvent(event);
      if (onChange) onChange(event);
      setGroupState(s => {
        if (evaluateGroupState(s) === value) return s;
        return [...s.fill(value)];
      });
    },
    indeterminate: currentState === states.INDETERMINATE,
    checked: currentState === states.CHECKED
  })), _react.default.createElement("ul", {
    className: baseClass,
    ref: containerRef
  }, _react.default.Children.map(children, (ch, i) => {
    return _react.default.createElement("li", {
      className: `${baseClass}-item`
    }, _react.default.cloneElement(ch, {
      checked: groupState[i] === states.CHECKED,
      indeterminate: groupState[i] === states.INDETERMINATE,
      disabled: rest.disabled || ch.props.disabled,
      prefix: rest.prefix || ch.props.prefix,
      onChange: event => {
        const value = valueFromEvent(event);
        if (ch.props.onChange) ch.props.onChange(event);
        setGroupState(s => {
          if (s[i] === value) return s;
          return s[i] = value, [...s];
        });
      }
    }));
  })));
});
exports.IndeterminateCheckboxGroup = IndeterminateCheckboxGroup;
IndeterminateCheckboxGroup.displayName = 'IndeterminateCheckboxGroup';
var _default = IndeterminateCheckboxGroup;
exports.default = _default;